import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../Logo";

export default function RealityNav({ t, onWatch, onTrailer }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="reality-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#0B0B0C]/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="alta-ribbon" />
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link to="/" data-testid="reality-nav-logo" className="flex items-center gap-4 vlink">
          <Logo variant="light" size={40} testid="reality-nav-alta-logo" />
          <span className="hidden md:flex items-center gap-3">
            <span className="condensed text-[20px] tracking-[0.08em] text-[#F1EDE6]">
              Casa <span className="text-[color:var(--alta-red-soft)]">Alta</span>
            </span>
            <span className="mono text-[10px] uppercase tracking-[0.28em] text-[#F1EDE6]/50">{t.nav_tag}</span>
          </span>
        </Link>

        <div className="flex items-center gap-4 md:gap-8">
          {onTrailer && (

            <button type="button" onClick={onTrailer} data-testid="reality-nav-trailer" className="mono text-[11px] uppercase tracking-[0.24em] text-[#F1EDE6] hover:text-[color:var(--alta-red-soft)] transition-colors">

              {t.nav_trailer}

            </button>

          )}
          <button
            type="button"
            onClick={onWatch}
            data-testid="reality-nav-watch"
            className="hidden sm:inline mono text-[11px] uppercase tracking-[0.24em] text-[#F1EDE6]/80 hover:text-[#F1EDE6] transition-colors"
          >
            {t.nav_watch}
          </button>
          <a
            href={t.premiere_url || t.channel_url}
            target="_blank"
            rel="noreferrer"
            data-testid="reality-nav-cta"
            className="btn-red-primary !py-2.5 !px-5 !text-[10px]"
          >
            {t.nav_cta}
          </a>
        </div>
      </div>
    </nav>
  );
}
